import { render, staticRenderFns } from "./ChufangLog.vue?vue&type=template&id=f8bf41b8&scoped=true"
import script from "./ChufangLog.vue?vue&type=script&lang=js"
export * from "./ChufangLog.vue?vue&type=script&lang=js"
import style0 from "./ChufangLog.vue?vue&type=style&index=0&id=f8bf41b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf41b8",
  null
  
)

export default component.exports